<template>
    <div style="display: inline-block;">
        <el-link v-bind="$attrs" v-on="$listeners" :underline="true" type="primary" :class="className"
                 @click="exportSaveFile"
                 v-if="canExport"
                 :disabled="loadingDownload">
            <i :class="`${loadingDownload?'el-icon-loading':'el-icon-download'}`" :style="iconStyle"></i>
            <span :style="txtStyle">{{ loadingDownload ? '导出中...' : lintTitle }}</span>
        </el-link>
        <el-tooltip class="item" effect="dark" content="无权限：导出" placement="top-start" v-else>
            <el-link v-bind="$attrs" :underline="false" type="info" :class="className">
                <i class="el-icon-download"></i><span :style="txtStyle">{{ lintTitle }}</span>
            </el-link>
        </el-tooltip>
    </div>
</template>

<script>
import FileSaver from 'file-saver';

export default {
    name: "ExportLink",
    props: {
        canExport: {
            type: Boolean,
            default() {
                return false
            }
        },
        lintTitle: {
            type: String,
            default() {
                return '导出表格';
            }
        },
        className: {
            type: String,
            default() {
                return 'export-excel';
            }
        },
        iconStyle: {
            type: String,
            default() {
                return 'font-size: 1rem'
            }
        },
        txtStyle: {
            type: String,
            default() {
                return 'font-size: 1rem'
            }
        }
    },
    data() {
        return {
            loadingDownload: false
        }
    },
    methods: {
        async exportSaveFile() {
            this.$notify({
                title: '开始导出，请耐心等候',
            });
            this.loadingDownload = true
            this.$emit('export')
            setTimeout(() => {
                this.loadingDownload = false
            }, 10000)
        },
        //导出excel文件
        exportSaveXlsx(response, title) {
            let isFileSaverSupported = !!new Blob;
            if (isFileSaverSupported) {
                let data = response.data
                let contentType = response.headers['content-type']
                let blob = new Blob([data], {
                    type: contentType
                });

                FileSaver.saveAs(blob, decodeURI(title + ".xlsx"), {autoBom: true});
                setTimeout(() => {
                    this.loadingDownload = false
                }, 500)
            } else {
                this.$message.warning('浏览器不支持导出文件')
            }
        }
    }
}
</script>

<style scoped>
.export-excel {
    font-size: 1rem;
}
</style>
